<footer class="pie-pagina">
  <div class="contenedor">
    <div class="contenido-footer">
      <div class="columna-footer">
        <div class="logo-footer">
          <img src="assets/svg/Logo-footer.svg" alt="REHOBOT">
        </div>
        <div class="siguenos-texto">Síguenos:</div>
        <div class="redes-sociales">
          <a href="https://www.facebook.com/share/17wmFJhTKW/?mibextid=wwXIfr" class="red-social facebook">
            <img src="assets/svg/facebook.svg" alt="Facebook">
          </a>
          <a href="https://www.instagram.com/corporacionrehobot.cg/" class="red-social instagram">
            <img src="assets/svg/instagram.svg" alt="Instagram">
          </a>
          <a href="#" class="red-social tiktok">
            <img src="assets/svg/tiktok.svg" alt="TikTok">
          </a>
          <a href="https://www.linkedin.com/company/corporacionrehobot" class="red-social linkedin">
            <img src="assets/svg/linkedin.svg" alt="LinkedIn">
          </a>
          <a href="https://www.youtube.com/channel/UCpzikgBT0OdVf_ZkjBMbDmw" class="red-social youtube">
            <img src="assets/svg/youtube.svg" alt="YouTube">
          </a>
        </div>
      </div>
      <div class="columna-footer">
        <h4>Corporación Rehobot</h4>
        <ul>
          <li><a routerLink="/nosotros">Sobre nosotros</a></li>
          <li><a routerLink="/productos">Nuestros productos</a></li>
          <li><a routerLink="/servicios">Nuestros Servicios</a></li>
        </ul>
      </div>
      <div class="columna-footer">
        <h4>Otros Enlaces</h4>
        <ul>
          <li><a routerLink="/trabaja-con-nosotros">Trabaja con nosotros</a></li>
          <li><a routerLink="/politica-privacidad">Política de privacidad y uso<br>de datos personales</a></li>
          <li><a routerLink="/politica-calidad">Política de calidad</a></li>
        </ul>
      </div>
      <div class="columna-footer">
        <h4>Contacto</h4>
        <ul>
          <li><a href="mailto:info@corporacionrehobot.com">info&#64;corporacionrehobot.com</a></li>
          <li><a href="tel:+51989011132">(51) 989 011 132</a></li>
        </ul>
      </div>
    </div>
    <div class="footer-inferior">
      <div class="copyright">© 2025 Rehobot. Todos los derechos reservados.</div>
      <div class="empresa-info">Corporación Rehobot Contratistas Generales. S.A.C - RUC 20538056988</div>
    </div>
  </div>
</footer>
